import Campaign from './campaign'
import { connect } from 'react-redux'
import { show as showComingSoon } from 'redux/modules/coming_soon_dialog'
import isOwnerSelector from 'redux/selectors/is_owner'
import { getCampaignSelector } from 'redux/selectors/campaign'
import canManageSelector from 'redux/selectors/can_manage'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  return {
    title: campaign.title,
    description: campaign.description,
    isOwner: isOwnerSelector(state, props),
    backgroundImage: campaign.background_image,
    hasCurrencyBalance: !!campaign.has_currency_balance, // TODO: wat
    currency: campaign.currency,
    canCreate: !state.current_user.moneypools_country_blocked,
    hasBalance: campaign.amount > 0,
    canManage: canManageSelector(state, props),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onShowComingSoon() {
      dispatch(showComingSoon())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Campaign)
